import { useMemo } from 'react';

import { getNodes } from '@/utils/graphqlUtils';

import { useFamilyTreeContext } from '../contexts';
import {
  EMPTY_PERSON_RELATIONSHIPS,
  FamilyRelationships,
  findPersonById,
  getPersonRelationships,
  SidebarPerson,
} from '../utils/relationshipUtils';

export interface UseFamilyTreeRelationshipsResult {
  selectedPerson?: SidebarPerson;
  relationships: FamilyRelationships;
  isLoading: boolean;
}

/**
 * Hook to get relationship data for the currently selected person
 */
export function useFamilyTreeRelationships(): UseFamilyTreeRelationshipsResult {
  const { state } = useFamilyTreeContext();
  const { selectedPersonId, familyTreeData, clientProfiles } = state;

  const result = useMemo(() => {
    if (!selectedPersonId || !familyTreeData) {
      return {
        selectedPerson: undefined,
        relationships: EMPTY_PERSON_RELATIONSHIPS,
        isLoading: !familyTreeData,
      };
    }

    const selectedPerson = findPersonById(
      selectedPersonId,
      getNodes(clientProfiles)
    );

    const relationships = getPersonRelationships(
      selectedPersonId,
      getNodes(clientProfiles)
    );

    return {
      selectedPerson,
      relationships,
      isLoading: false,
    };
  }, [selectedPersonId, familyTreeData, clientProfiles]);

  return result;
}
